import React from 'react';
import profilePhoto2 from '../assets/BZ5_7667.jpeg';
import { Badge } from '../ui/Badge';
import { PrimaryButton } from '../ui/Button';
import { TelegramIcon, EmailIcon } from '../ui/Icons';
import { trackClick, trackExternalLink } from '../utils/yandexMetrika';

const ContactSection: React.FC = () => {
    const telegramLink = "https://t.me/vip777swag";
    
    const socialLinks = [
        {
            title: "Telegram",
            href: telegramLink,
            icon: <TelegramIcon />
        },
        {
            title: "Email",
            href: "mailto:darikarpenko@yandex.ru",
            icon: <EmailIcon />
        }
    ];

    return (
        <section className="section cta-final" id="contact">
            <div className="container">
                <div className="cta-grid">
                    <div className="hero-visual">
                        <div className="glass-frame">
                            <img className="profile-photo-main" src={profilePhoto2} alt="Daria Karpenko"/>
                        </div>
                    </div>

                    <div className="cta-text-block">
                        <Badge>Бесплатная консультация</Badge>
                        <h2 className="section-title text-left mt-small">
                            Давайте разберём <br/>
                            <strong>вашу задачу</strong>
                        </h2>
                        <p className="hero-description">
                            Я лично изучу ваш проект, подсвечу технические риски и предложу оптимальный набор технологий для запуска.
                        </p>

                        <div className="cta-actions-wrapper">
                            <PrimaryButton 
                                href={telegramLink}
                                target="_blank"
                                rel="noreferrer"
                                onClick={() => {
                                    trackClick('discuss_project');
                                    trackExternalLink(telegramLink);
                                }}
                            >
                                Обсудить проект
                            </PrimaryButton>
                            <div className="social-icons-grid">
                                {socialLinks.map((link) => (
                                    <a
                                        key={link.title}
                                        href={link.href}
                                        className="icon-link-circle small click-anim"
                                        title={link.title}
                                        target="_blank"
                                        rel="noreferrer"
                                        onClick={() => {
                                            trackClick(`contact_${link.title.toLowerCase()}`);
                                            trackExternalLink(link.href);
                                        }}
                                    >
                                        {link.icon}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;